import React, { useEffect, useState } from 'react';
import './Banner.css';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { EVENT_DATE_LABEL_CORTO, EVENT_VENUE } from '../config/event';
import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion';

const Banner = () => {
  const [logoRef, logoVisible] = useScrollAnimation(0.3);
  const [subtitleRef, subtitleVisible] = useScrollAnimation(0.3);
  const [descriptionRef, descriptionVisible] = useScrollAnimation(0.3);
  const [pautaRef, pautaVisible] = useScrollAnimation(0.3);

  // Parallax offset state
  const [parallaxOffset, setParallaxOffset] = useState(0);
  const sinMovimiento = usePrefersReducedMotion();

  // Parallax effect on scroll
  useEffect(() => {
    if (sinMovimiento) {
      setParallaxOffset(0);
      return undefined;
    }

    let frame = null;

    const update = () => {
      frame = null;
      // El fondo se mueve mas lento que el scroll
      setParallaxOffset(window.pageYOffset * 0.5);
    };

    // Pasivo y agrupado por frame: evita bloquear el scroll del navegador.
    const handleScroll = () => {
      if (frame === null) {
        frame = requestAnimationFrame(update);
      }
    };

    update();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      if (frame !== null) cancelAnimationFrame(frame);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [sinMovimiento]);

  return (
    <section
      className="hero"
      id="about"
      style={{ '--parallax': `${parallaxOffset}px` }}
    >
      {/* Trama de lineas del hero. Los halos los pone <Atmosfera />. */}
      <div className="hero-lines hero-lines--izq" aria-hidden="true" />
      <div className="hero-lines hero-lines--der" aria-hidden="true" />

      <div className="hero-container">
        <div className="hero-content">
          <div
            ref={logoRef}
            className={`hero-logo ${logoVisible ? 'fade-in-up' : 'animate-on-scroll'}`}
          >
            <img src="/images/hero/dentsu-day-white.svg" alt="Dentsu Day" className="hero-logo-img" />
          </div>

          <div
            ref={subtitleRef}
            className={`hero-subtitle ${subtitleVisible ? 'fade-in-left' : 'animate-on-scroll'}`}
          >
            Gracias por ser parte de un encuentro para <strong>conectar, inspirar y anticipar el futuro de las marcas</strong>
          </div>

          <div
            ref={descriptionRef}
            className={`hero-description ${descriptionVisible ? 'fade-in-up' : 'animate-on-scroll'}`}
          >
            <p>
              <strong>dentsu Day 2026</strong> reunió a líderes, clientes y aliados en el {EVENT_VENUE.name} para conversar sobre inteligencia artificial generativa, retail media y búsqueda conversacional: las fuerzas que están redefiniendo cómo las marcas encuentran y son encontradas.
            </p>
          </div>

          {/* Version post-evento: sin cuenta regresiva, solo la linea de pauta
              como registro de cuando y donde fue. */}
          <div
            ref={pautaRef}
            className={`hero-countdown ${pautaVisible ? 'fade-in-up' : 'animate-on-scroll'}`}
          >
            <p className="countdown-pauta">
              {EVENT_DATE_LABEL_CORTO} · {EVENT_VENUE.shortName.toUpperCase()}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;